<div
  class="popup-ad-overlay"
  *ngIf="visible && popup"
  [class.popup-ad-overlay--closing]="closing"
  (click)="onBackdropClick($event)"
  role="presentation">
  <div
    class="popup-ad-dialog"
    [class.popup-ad-dialog--media-only]="isMediaOnly"
    [class.popup-ad-dialog--landscape]="mediaOrientation === 'landscape'"
    [class.popup-ad-dialog--portrait]="mediaOrientation === 'portrait'"
    [class.popup-ad-dialog--square]="mediaOrientation === 'square'"
    [@popupSpring]
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="popup.title">
    <button type="button" class="popup-ad-close" (click)="close($event)" aria-label="Close popup">
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="popup-ad-media" *ngIf="popup.imageUrl">
      <img
        *ngIf="!isVideoUrl(popup.imageUrl)"
        [appMediaSrc]="popup.imageUrl"
        [alt]="popup.title"
        loading="lazy"
        fetchpriority="low"
        (load)="onMediaLoaded($event)" />
      <video
        *ngIf="isVideoUrl(popup.imageUrl)"
        [appMediaSrc]="popup.imageUrl"
        controls
        playsinline
        muted
        (loadedmetadata)="onMediaLoaded($event)"></video>
    </div>

    <div class="popup-ad-body" *ngIf="hasTextContent">
      <h2 class="popup-ad-title" *ngIf="popup.title">{{ popup.title }}</h2>
      <div
        *ngIf="popup.contentHtml"
        class="popup-ad-content"
        [innerHTML]="popup.contentHtml"></div>
      <button
        *ngIf="popup.buttonText"
        type="button"
        class="button primary popup-ad-action"
        (click)="onActionClick()">
        {{ popup.buttonText }}
      </button>
    </div>
  </div>
</div>
